module.exports = __webpack_public_path__ + "static/media/PhuketListPreview.fc851b10.png";